export * from './getAppAssociatedDomains';
